/**
 * When the user returns via the browser Back button from another origin, the page may be
 * restored from the back-forward cache without re-running app bootstrap. Register a one-time
 * listener so we reload and refetch state (auth, queries, SIP) instead of showing stale UI.
 */

export function registerReloadOnBfCacheRestore(): void {
  window.addEventListener('pageshow', (event: PageTransitionEvent) => {
    if (event.persisted) {
      window.location.reload();
    }
  });
}
